export default __webpack_public_path__ + "static/media/Green.00f1cfe9.png";